"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * @Author: liujunhong
 * @Date: 2022/10/14
 * @Desc: cookie
 */
var cookie = {
  get: function get(keys) {
    var mat = new RegExp("(^|[^a-z])".concat(keys, "=(.*?)(;|$)"), 'i').exec(document.cookie);
    return mat ? decodeURIComponent(mat[2]) : '';
  },
  set: function set(params) {
    var name = params.name,
      value = params.value,
      expires = params.expires,
      path = params.path,
      domain = params.domain,
      secure = params.secure;
    var cookieText = "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value));
    if (expires instanceof Date) {
      cookieText += "; expires=".concat(expires.toUTCString());
    }
    if (path) {
      cookieText += "; path=".concat(path);
    }
    if (domain) {
      cookieText += "; domain=".concat(domain);
    }
    if (secure) {
      cookieText += '; secure';
    }
    document.cookie = cookieText;
  }
};
var _default = cookie;
exports.default = _default;